import styled from "styled-components";

export const MessagesScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  -webkit-overflow-scrolling: touch;
  outline: none;
`;

export const MessageRow = styled.div`
  margin-bottom: 12px;
  display: flex;
  justify-content: ${(p) => (p.$align === "end" ? "flex-end" : "flex-start")};
`;

export const Bubble = styled.div`
  padding: 10px 14px;
  border-radius: 14px;
  background-color: ${(p) => (p.$variant === "agent" ? "#1677ff" : "#f5f5f5")};
  color: ${(p) => (p.$variant === "agent" ? "#fff" : "#000")};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  /* Responsive fixed widths */
  max-width: 90vw; /* mobile default */

  @media (min-width: 768px) {
    max-width: 70vw; /* tablets */
  }

  @media (min-width: 992px) {
    max-width: 50vw; /* desktops */
  }

  /* Improve text readability */
  line-height: 1.45;
  word-wrap: break-word;
  word-break: break-word;
`;

export const Meta = styled.div`
  font-size: 10px;
  margin-top: 4px;
  opacity: 0.75;
`;
